import { useEffect } from "react";

type UseKeyboardControlArguments = {
  disabled?: boolean;
  playing: boolean;
  framesPerSecond: number;
  progress: number;
  onSeek: (fraction: number) => void;
  onToggle: (playing: boolean) => void;
  start: number;
  end: number;
};

export const useKeyboardControl = ({
  disabled,
  framesPerSecond,
  playing,
  progress,
  onSeek,
  onToggle,
  start,
  end,
}: UseKeyboardControlArguments): void => {
  useEffect(() => {
    const seekToRelativeFrame = (frame: number) => {
      const newProgress = progress + frame * (1 / framesPerSecond);

      onSeek(newProgress > end || newProgress < start ? start : newProgress);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (disabled) return;

      if (e.code === "Space") {
        if (playing) {
          onToggle(false);
        } else {
          onToggle(true);
        }
      } else if (e.code === "ArrowLeft" && !playing) {
        seekToRelativeFrame(e.shiftKey ? -10 : -1);
      } else if (e.code === "ArrowRight" && !playing) {
        seekToRelativeFrame(e.shiftKey ? 10 : 1);
      }
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [disabled, end, framesPerSecond, onSeek, onToggle, playing, progress, start]);
};
